import { Injectable } from '@angular/core';
import { ConstantsService } from "../constants.service";

@Injectable({
  providedIn: 'root'
})
export class LocationHelperService {

    constructor(private constants: ConstantsService) { }

    ProcessBranchName(url: string, absUrl: string[]): string {

        if (this.doesUrlContainBranchName(absUrl)) {
            url = url + '/' + this.getBranchName(absUrl);
        }

        return url;
    }

    private getBranchName(absUrl: string[]): string {
        return absUrl[3];
    }

    private doesUrlContainBranchName(absUrl: string[]): boolean {
        let possibleBranchName = this.getBranchName(absUrl);

        if (!((<any>Object).values(this.constants.AppDisplayTypes).includes(possibleBranchName))) {
            return true;
        }

        return false;
    }
}
